import {Link} from 'react-router-dom';
import {useContext} from "react";
import DataContext from "../components/DataContext";
import { AiFillFolder } from "react-icons/ai";
import styles from '../scss/MainPage.module.scss';

const MainPage = () => {
    const {data} = useContext(DataContext);
    return (
        <div>
            <ul className={styles.listStyle}>
                {
                    data && data.length>0 && data.map((item, idx)=>
                        <li key={idx}>
                            <Link to={`/arhiva/${item.name}`}>
                                <AiFillFolder />{item.name}
                            </Link>
                            <hr></hr>
                        </li>)
                }
            </ul>
        </div>);
};

export default MainPage;